'use client'

import { useContext } from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { IconButton } from '@mui/material'
import { ChevronLeft } from '@mui/icons-material'
import { PageContext } from '../PageContext'
import Actions from './Actions'
import { Section } from '@wolfdanepug/common-react'
import { useNavigate } from 'react-router'

export interface PageHeaderProps {
	sx?: any
	redirectHandler?: any
}

export const PageHeader = ({ sx = {} }: PageHeaderProps) => {
	const { usePageState, onPageAction, usePageData } = useContext(PageContext)
	const {
		title,
		description,
		actions = [],
		sx: stateStyles = {},
		open,
		canGoBack = false,
		goBackParams = []
	} = usePageState()
	const data = usePageData()
	const navigate = useNavigate()

	const handleBackRequest = () => {
		if (typeof canGoBack === 'string') {
			const query =
				goBackParams.length > 0
					? goBackParams.reduce((acc: any, param: string | string[]) => {
							const isString = typeof param === 'string'
							const attr = isString ? param : param[1]
							const key = isString ? param : param[0]
							return {
								...acc,
								[attr]: data[key]
							}
						}, {})
					: null
			let redirect = `${canGoBack}`
			query && (redirect += `?${new URLSearchParams(query).toString()}`)
			navigate(redirect)
		} else {
			navigate(-1)
		}
	}

	if (!open) return null
	const enabledActions = actions.filter((action: any) => action.enabled)

	return (
		<Section>
			{/*<Box sx={{ ...styles.root, ...sx.root, ...stateStyles.root }}>*/}
			{canGoBack && (
				<Box>
					<IconButton onClick={handleBackRequest}>
						<ChevronLeft />
					</IconButton>
				</Box>
			)}
			<Box sx={{ ...styles.content, ...sx.root }}>
				{(title || description) && (
					<Box sx={styles.textBlock}>
						{title && (
							<Typography variant="h1" sx={{ ...sx.title, ...stateStyles.title }}>
								{title}
							</Typography>
						)}
						{description && (
							<Typography variant="body1" sx={{ ...sx.description, ...stateStyles.description }}>
								{description}
							</Typography>
						)}
					</Box>
				)}
				{enabledActions && (
					<Box sx={styles.actions}>
						<Actions items={enabledActions} onClick={onPageAction} />
					</Box>
				)}
			</Box>
			{/*</Box>*/}
		</Section>
	)
}

const styles = {
	root: {
		display: 'flex',
		gap: 2
	},
	content: {
		display: 'flex',
		flex: 1,
		justifyContent: 'space-between',
		alignItems: 'center'
	},
	textBlock: {},
	actions: {}
}
